/**
 * 작성자 : 한영광, 홍선영
 * 날짜 : 2023.05.16
 * 기능 : API 요청 함수
 */

import axios from 'axios';
import Cookies from 'js-cookie';
import { handleFlutterLogout } from '../utils/flutterBridge';
import { delay } from './delayPromise';

export const registerId = async (id: string) => {
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/register?userId=${id}`, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerSiteJoinInfo = async (hCd: string, sCd: string) => {
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/register/siteJoinInfo?hCd=${hCd}&sCd=${sCd}`, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerTempPwd = async (userId: string, eMail: string) => {
  const params = new URLSearchParams();
  params.append('userId', userId);
  params.append('eMail', eMail);

  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .patch(`${process.env.REACT_APP_BASE_URL}/register/tempPwd`, params, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerSiteInfo = async (hCd: string) => {
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/register/siteInfo?hCd=${hCd}`, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerSignup = async (signupInfo: any, gCd: string, siteName: any) => {
  const params = new URLSearchParams();

  params.append('userId', signupInfo?.userId);
  params.append('userName', signupInfo?.userName);
  params.append('gCd', gCd);
  params.append('hCd', siteName?.hCd);
  params.append('sCd', siteName?.sCd);
  params.append('sjCd', siteName?.sjCd);
  params.append('hpNum', signupInfo?.hpNum);
  params.append('telNum', signupInfo?.telNum);
  params.append('eMail', signupInfo?.eMail);
  params.append('ipInfo', signupInfo?.ipInfo);
  // params.append('approvalYn', signupInfo?.approvalYn);
  // params.append('pwdCheckyn', signupInfo?.pwdCheckyn);

  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/register/signup`, params, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerSignin = async (loginInfo: any) => {
  const params = new URLSearchParams();
  params.append('userId', loginInfo?.id);
  params.append('userPwd', loginInfo?.password);
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/register/signin`, params, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerPwdchangeDate = async (userId: string, accessToken: string) => {
  const params = new URLSearchParams();
  params.append('userId', userId);

  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
      authorization: `Bearer ${accessToken}`,
    },
  };

  return axios
    .patch(`${process.env.REACT_APP_BASE_URL}/register/pwdChangeDate`, params, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch(async (e: any) => {
      if (e.response.status === 401) {
        if (e.response.data.statusCode === 4018) {
          Cookies.remove('prosafeToken');
          Cookies.remove('refreshToken');
          window.location.replace('/?auth=fail');
          return e.response;
        }
        const res2 = await registerRefresh();
        if (res2.status === 200) {
          const res3: any = await registerPwdchangeDate(userId, accessToken);
          return res3;
        }
      }
      return e.response;
    });
};

export const registerPwd = async (userId: string, newPassword: string, accessToken: string) => {
  const params = new URLSearchParams();
  params.append('userId', userId);
  params.append('userPwd', newPassword);

  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
      authorization: `Bearer ${accessToken}`,
    },
  };

  return axios
    .patch(`${process.env.REACT_APP_BASE_URL}/register/pwd`, params, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch(async (e: any) => {
      if (e.response.data.statusCode === 401) {
        const res2 = await registerRefresh();
        if (res2.status === 200) {
          const res3: any = await registerPwd(userId, newPassword, accessToken);
          return res3;
        }
      }
      return e.response;
    });
};

export const registerIp = async () => {
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/register/ip`, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerHeadInfo = async (subDomain: string) => {
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/register/headInfo?subDomain=${subDomain}`, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerCompanyInfo = async (subDomain: string) => {
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/register/companyInfo?subDomain=${subDomain}`, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch((e: any) => {
      return e.response;
    });
};

export const registerEmail = async (userId: string, eMail: string) => {
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  };

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/register/email?userId=${userId}&eMail=${eMail}`, config)
    .then((res: any) => {
      if (res.status === 210) {
        alert('관리자가 설정을 변경하여 리로드됩니다.');
        window.location.replace('/?oeditYn=Y');
      }
      return res;
    })
    .catch(async (e: any) => {
      return e.response;
    });
};
let refreshPromise: Promise<any> | null = null;
// 서버가 응답하지 않을 때 refresh 요청이 영원히 대기하면, refreshPromise가 비워지지 않아
// 이후 모든 401 처리가 같은 요청을 기다리며 토큰을 다시 갱신하지 못한다(2026-10-07 장애).
// 시간 제한을 넘기면 서버 장애(응답 없음)로 처리한다. 상황판은 서버가 응답할 때까지 기다린 뒤 새로고침하고,
// 그 외 화면은 로그인 화면으로 보낸다.
const REFRESH_TIMEOUT_MS = 10000;

// 응답이 없거나(연결 끊김·타임아웃) 5xx면 서버 장애로 판단
const isServerUnavailable = (e: any) => !e?.response || e.response.status >= 500;

// 상황판 전용: 서버가 응답할 때까지 refresh 요청을 간격을 늘려가며 재시도한 뒤 리로드
let waitingServer = false;
const waitServerAndReloadBoard = async () => {
  if (waitingServer) return;
  waitingServer = true;
  const params = new URLSearchParams();
  params.append('refreshToken', Cookies.get('refreshToken') ?? '');
  // 재시도 요청도 응답 없이 멈추면 루프가 끝나지 않으므로 같은 시간 제한을 둔다
  const config = { headers: { 'Content-type': 'application/x-www-form-urlencoded' }, timeout: REFRESH_TIMEOUT_MS };
  let delayMs = 5000;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    // eslint-disable-next-line no-await-in-loop
    await delay(delayMs);
    try {
      // eslint-disable-next-line no-await-in-loop
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/register/refresh`, params, config);
      const data = res?.data?.data;
      data?.accessToken && Cookies.set('prosafeToken', data.accessToken);
      data?.refreshToken && Cookies.set('refreshToken', data.refreshToken);
      break;
    } catch (e: any) {
      if (!isServerUnavailable(e)) break; // 서버는 응답함(인증 오류 등) → 리로드해서 상황판 계정으로 재로그인
    }
    delayMs = Math.min(delayMs * 2, 30000);
  }
  window.location.reload();
};

export const registerRefresh = async () => {
  if (refreshPromise) return refreshPromise;
  const params = new URLSearchParams();
  const refreshToken: any = Cookies.get('refreshToken');
  params.append('refreshToken', refreshToken);
  const config = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    timeout: REFRESH_TIMEOUT_MS,
  };
  /**
   * 수정자 : 한영광
   * 수정일자 : 2024.9.2
   * 문제 : 상황판에서 로그인 페이지로 이동되는 문제가 발생함.
   * 수정내용 : refresh토큰이 만료된 경우 로그인 페이지로 보내서 다시 로그인 하도록 유도하는데
   *        현재 페이지가 상황판인 경우 리로드 하도록 처리하여 상황판용 사용자 정보로 다시 로그인되도록 수정함
   */
  refreshPromise = axios
    .post(`${process.env.REACT_APP_BASE_URL}/register/refresh`, params, config)
    .then((res: any) => {
      refreshPromise = null;
      const { data } = res.data;
      data?.accessToken && Cookies.set('prosafeToken', data.accessToken);
      data?.refreshToken && Cookies.set('refreshToken', data.refreshToken);

      // Flutter 앱에 토큰 갱신 알림
      if (window.TokenRefresh) {
        window.TokenRefresh.postMessage(
          JSON.stringify({
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
          })
        );
        console.log('[React] Flutter에 토큰 갱신 알림 전송 완료');
      }

      return res;
    })
    .catch((e: any) => {
      refreshPromise = null;
      /**
       * 수정자 : 홍선영
       * 수정일자 : 2026.09.22
       * 문제 : 서버 장애(DB Lock·재시작) 중 토큰 갱신이 실패하면 상황판이 즉시 리로드되고,
       *        리로드 직후 로그인도 실패해 서버 복구 후에도 빈 화면으로 멈춤
       * 수정내용 : 서버 오류(응답 없음·5xx)면 리로드하지 않고 서버 응답을 기다린 뒤 리로드함.
       *          refresh 토큰 만료 등 인증 오류는 기존처럼 즉시 리로드
       */
      if (window.location.pathname === '/board') {
        if (isServerUnavailable(e)) waitServerAndReloadBoard();
        else window.location.reload();
      } else {
        handleFlutterLogout();
        window.location.replace('/?auth=fail');
        Cookies.remove('prosafeToken');
        Cookies.remove('refreshToken');
      }
      return e.response;
    });
  return refreshPromise;
};
